import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import Products from '../../Models/Products';
import Pagination from "react-js-pagination";
import { Header } from '../Common';
import {withTranslation} from "react-i18next";
import Common from "../../Models/Common";
import { ToastContainer, toast } from "react-toastify";
var striptags = require('striptags');
class ServiceList extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('SELLER_SERVICE_LIST.LOGIN_ALERT'));
            // this.props.history.push('/login/seller');
            this.props.history.push('/login/seller');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            productsList: [],
            user: logged_user,
            total: [],
            successAlert: false
        };
        // this.getTotal();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        let { successMsg } = this.props.location.state || false;
        if(successMsg){
            toast(this.props.t('SELLER_SERVICE_LIST.SUCCESS_MESSAGE'),{
                position: "top-center"
            });
        }
        if (successMsg && !this.state.successAlert) {
            this.setState({ successAlert: true });
        }
    }
    componentWillMount() {
        Products.getProductList(this.state.user.id, 1).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage, total: res.data.total })
            }
        })
    }
    handlePageChange(pageNumber) {
        Products.getProductList(this.state.user.id, pageNumber).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload, total: res.data.total })
                this.setState({ activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage });
                window.scrollTo(0, 0)
            }
        })
    }
    render() {
        let { successMsg } = this.props.location.state || {};
        if (this.state.successAlert && successMsg) {
            this.props.history.replace({ pathname: '/service-list', state: { successMsg: false } });
        }
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <ToastContainer />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5  input_name big_font text-left" style={{ width: '100%', fontSize: '20px' }} >
                                    {this.props.t('SELLER_SERVICE_LIST.SELLER_SERVICE_LIST_TITLE')}
                                        </div>
                                <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                    <div className="service-list-divs">{this.props.t('SELLER_SERVICE_LIST.SELLER_SERVICE_LIST')}  </div>
                                    {this.state.productsList.map((group, index) =>
                                        <div className="service-list-divs" key={index}>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className='mt-3' >
                                                        <img alt="" src={Common.baseUrl + group.img} style={{ width: "100%", height: "150px", objectFit: "cover" }} /></div>
                                                    <div style={{ backgroundColor: "#ddd", height: "20px", textAlign: "center", color: "white" }}>{parseInt(group.price)} {this.props.t('SELLER_SERVICE_LIST.YEN')} </div>
                                                </div>
                                                <div className="col-md-9">
                                                    <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "18px", borderBottom: "1px solid #bababa" }}>
                                                        <Link to={{
                                                            pathname: `/categories-details/${group.id}`,
                                                            state: { id: group.id }
                                                        }} className="" style={{ textDecoration: 'none' }} className="category-right">
                                                            {group.title}
                                                        </Link>
                                                    </div>
                                                    <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "12px" }}>
                                                        {renderHTML(group.trimed_long_desc)}
                                                    </div>
                                                    <div style={{ textAlign: "right" }}>
                                                        <Link to={{
                                                            pathname: `/edit-product-upload/${group.id}`,
                                                            state: { id: group.id }
                                                        }} className="sky-a" href="#">
                                                            {this.props.t('SELLER_SERVICE_LIST.EDIT_BTN')}
                                                            </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <Pagination
                                hideNavigation
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                totalItemsCount={this.state.total}
                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                onChange={this.handlePageChange.bind(this)}
                            />
                        </div>
                        <div className="col-md-0"></div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for Desktop view
        if (isDesktop) {
            return (
                <div  className="wrapper">
                    <Header />
                    <ToastContainer />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: '100%' }} >
                                            {this.props.t('SELLER_SERVICE_LIST.SELLER_SERVICE_LIST_TITLE')}
                                    </div>
                                        <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                            <div className="service-list-divs">{this.props.t('SELLER_SERVICE_LIST.SELLER_SERVICE_LIST')}  </div>
                                            {this.state.productsList.map((group, index) =>
                                                <div className="service-list-divs" key={index}>
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                {/* <div style={{ backgroundColor: "#ddd", height: "20px", textAlign: "center", color: "white" }}>{group.title}</div> */}
                                                                {/* {/ <div><img alt="" src={require("../../assets/images/image1.jpeg")} height="auto" width='100%' /></div> /} */}
                                                                <div className='mt-3' >
                                                                    <img alt="" src={Common.baseUrl + group.img} style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
                                                                <div style={{ backgroundColor: "#ddd", height: "20px", textAlign: "center", color: "white" }}>{parseInt(group.price)} {this.props.t('SELLER_SERVICE_LIST.YEN')} </div>
                                                            </div>
                                                            <div className="col-md-9">
                                                                <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "18px", borderBottom: "1px solid #bababa" }}>
                                                                    <Link to={{
                                                                        pathname: `/categories-details/${group.id}`,
                                                                        state: { id: group.id }

                                                                    }} style={{ textDecoration: 'none' }} className="category-right">
                                                                        {group.title}
                                                                    </Link>
                                                                </div>
                                                                <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "12px" }}>
                                                                    {/* {striptags(group.trimed_long_desc)} */}
                                                                    {/* {group.trimed_long_desc.split('\n').map(function (item, key) {
                                                                    return (
                                                                        <span key={key}>
                                                                            {item}
                                                                            <br />
                                                                        </span>
                                                                    )
                                                                })} */}
                                                                    {renderHTML(group.trimed_long_desc)}
                                                                </div>
                                                                <div style={{ textAlign: "right" }}>
                                                                    <Link to={{
                                                                        pathname: `/edit-product-upload/${group.id}`,
                                                                        state: { id: group.id }
                                                                    }} className="sky-a" href="#">
                                                                        {this.props.t('SELLER_SERVICE_LIST.EDIT_BTN')}
                                                            </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6"></div>
                                <div className="col-md-6">
                                    <Pagination
                                        hideNavigation
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.total}
                                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div>
                                <div className="col-md-0"></div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { ServiceList }
ServiceList = withTranslation('seller')(ServiceList);
